<template>
  <footer class="page-footer">
    <p v-if="isHavePrice" class="goods-price">
      <span>合计:</span>
      <span class="red-text">
        <i class="iconfont icon-renminbi"></i>
        {{ goodsPrice }}
      </span>
    </p>
    <button @click="doBroadcast">{{ btnText }}</button>
  </footer>
</template>

<script>
export default {
  name: 'ScopeContentFooter',
  props: {
    btnText: {
      type: String
    },
    isHavePrice: {
      type: Boolean
    },
    goodsPrice: {
      type: Number
    }
  },
  methods: {
    doBroadcast: function() {
      if (this.isHavePrice) {
        this.$emit('createOrder');
      } else {
        this.$emit('showHideMask', 'showMask');
      }
    }
  }
};
</script>

<style scoped lang="less">
@import '../../style/variable';
@import '../../style/public';

footer {
    border-top: 1px solid #888;
}
.page-footer {
  display: flex;
  justify-content: initial;
  align-items: center;
  flex-wrap: initial;
  flex-direction: initial;
  border-top: 1px solid #ddd;
  background-color: #fff;
}
.page-footer button {
    flex: 1;
    line-height: 1.2rem;
    text-align: center;
    border: none;
    background-color: #E77618;
    color: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.2);
    font-size: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/child-components/ScopeContentFooter.vue